const PREFIX = 'MEMBER_PROFILE_FACILITY_INFO_';

export const GET_FACILITIES = `${PREFIX}GET_FACILITIES`;
export const RENDER_FACILITIES = `${PREFIX}RENDER_FACILITIES`;